import { useIntl } from "react-intl";

import type { THotelRoom } from "@/features/hotels/types/types";
import {
  boardBasisMessages,
  isKnownBoardBasis,
} from "@/features/hotels/utils/boardBasis";

type HotelRoomTitleProps = Pick<THotelRoom, "name" | "board" | "occupancy">;

export const HotelRoomTitle = ({
  name,
  board,
  occupancy,
}: HotelRoomTitleProps) => {
  const intl = useIntl();

  return (
    <>
      {`${name} - ${isKnownBoardBasis(board) ? intl.formatMessage(boardBasisMessages[board]) : board} - ${intl.formatMessage(
        {
          defaultMessage:
            "{adultsCount, plural, one {# Adult} other {# Adults}}{childrenCount, plural, =0 {} other {, {childrenCount, plural, one {# Child} other {# Children}}}}",
          description: "Compact summary of adult and child guest counts",
        },
        {
          adultsCount: occupancy.numberOfAdults,
          childrenCount: occupancy.numberOfChildren,
        },
      )}
    `}
    </>
  );
};
